import { type RangesData } from './useGetDiscountRanges'

interface DiscountPercentageData {
  currentDiscountPercentage: number | undefined
  firstDiscountPercentage: number | undefined
}

export const useGetDiscountPercentages = (
  ranges: RangesData[],
  selectedQuantity: number,
): DiscountPercentageData => {
  const getFirstDiscountPercentage = (): number | undefined => {
    const firstRange = ranges.find((range) => range.discountPercentage !== 0)

    if (!firstRange) {
      return undefined
    }

    return firstRange.discountPercentage
  }

  const getCurrentDiscountPercentage = (): number | undefined => {
    const currentRange = ranges.find(
      (range) =>
        selectedQuantity >= range.rangeStart &&
        (range.rangeEnd === undefined || selectedQuantity <= range.rangeEnd),
    )

    if (!currentRange) {
      return undefined
    }

    return currentRange.discountPercentage
  }

  return {
    currentDiscountPercentage: getCurrentDiscountPercentage(),
    firstDiscountPercentage: getFirstDiscountPercentage(),
  }
}
